export var Global = {
    envMap: null,
    deviceOrientationAvailable: null,
    isGyroActive: false,
    isMobile: null,
    timeUp: false,
    gameStarted: false,
    score: 0,
    autoRotate: false,
}